module.exports = __webpack_public_path__ + "img/35.a2355f7e.png";